import { Link, NavLink, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function AdminLayout() {
  const { logout, user } = useAuth();
  const nav = useNavigate();

  const handleLogout = async () => {
    await logout();
    nav("/admin/login");
  };

  const links = [
    { to: "/admin", label: "Dashboard", end: true },
    { to: "/admin/works", label: "Works" },
    { to: "/admin/inquiries", label: "Inquiries" },
    { to: "/admin/settings", label: "Settings" },
    { to: "/admin/about", label: "About" },
    { to: "/admin/contact", label: "Contact" },
    { to: "/admin/marketing", label: "Marketing" },
    { to: "/admin/blog", label: "Blog" },
    { to: "/admin/album", label: "Album" },
    { to: "/admin/typography", label: "Typography" },
    { to: "/admin/account", label: "Account" },
  ];

  return (
    <div className="admin-shell min-h-screen bg-[#0A0A0C] text-white flex flex-col md:flex-row">
      <aside className="md:w-64 md:min-h-screen border-b md:border-b-0 md:border-r border-white/5 p-6 md:p-8 flex flex-col">
        <Link to="/" className="overline mb-12 hover:text-[#C9A050] transition-colors">
          ← Artistry Perspectives
        </Link>
        <nav className="flex md:flex-col gap-2 md:gap-1 flex-1 overflow-x-auto">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.end}
              data-testid={`admin-nav-${l.label.toLowerCase()}`}
              className={({ isActive }) =>
                `px-4 py-3 text-sm tracking-wide transition-all whitespace-nowrap ${
                  isActive
                    ? "bg-white/5 text-white border-l-2 border-[#C9A050]"
                    : "text-[#8A8A93] hover:text-white hover:bg-white/5"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>
        <div className="hidden md:block pt-6 border-t border-white/5">
          <p className="text-xs text-[#8A8A93] mb-2">Signed in as</p>
          <p className="text-sm mb-4">{user?.email}</p>
          <button
            onClick={handleLogout}
            data-testid="admin-logout"
            className="overline text-[#8A8A93] hover:text-[#C9A050] transition-colors"
          >
            Sign out →
          </button>
        </div>
      </aside>
      <main className="flex-1 p-6 md:p-12 max-w-full overflow-x-hidden">
        <Outlet />
      </main>
    </div>
  );
}
